module.exports = __webpack_public_path__ + "img/itomanman_comic13.b7eaa89f.jpg";